'use client'

import { useTranslations } from 'next-intl'
import { ArrowUpRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Link } from '@/i18n/navigation'
import { CHOOSER_CARDS } from './an-truong.constants'

export const ChooserSection = () => {
  const t = useTranslations('landing_an_truong.chooser')

  return (
    <section className='w-full bg-black px-4 py-14 text-white lg:px-[60px] lg:py-[120px]'>
      <div className='flex flex-col gap-3 lg:gap-4'>
        {/* Title & Sub */}
        <h2 className='font-criteria text-[28px] font-semibold leading-[41px] tracking-[-0.56px] text-white lg:text-[65px] lg:font-medium lg:leading-[90px] lg:tracking-[-1.3px]'>
          {t('title')}
        </h2>
        <p className='font-sans text-base leading-6 text-[#d1d1d1] lg:text-lg'>
          {t('subtitle')}
        </p>

        {/* Cards - Grid on desktop */}
        <div className='mt-3 grid grid-cols-1 gap-3 lg:mt-8 lg:grid-cols-3 lg:gap-5'>
          {CHOOSER_CARDS.map((card) => (
            <div
              key={card.key}
              className='flex flex-col justify-between gap-5 rounded-[18px] bg-[#1a1a1a] p-[22px] lg:p-7'
            >
              <div className='flex flex-col gap-5'>
                {/* Head */}
                <div className='flex flex-col gap-1'>
                  <span className='font-sans text-sm font-semibold leading-5 text-[#7985e5]'>
                    {t(`cards.${card.key}.when`)}
                  </span>
                  <h3 className='font-criteria text-2xl font-semibold leading-[35px] tracking-[-0.56px] text-white lg:text-[28px] lg:leading-[41px]'>
                    {t(`cards.${card.key}.name`)}
                  </h3>
                </div>

                {/* Tagline */}
                <p className='font-sans text-base leading-6 text-[#e5e5e5] lg:text-lg'>
                  {t(`cards.${card.key}.tagline`)}
                </p>

                {/* Facts */}
                <div className='flex flex-col gap-2.5'>
                  {/* Loại */}
                  <div className='flex items-center justify-between border-t border-[#333] pt-2.5'>
                    <span className='font-sans text-sm text-[#d1d1d1]'>
                      {t('label_type')}
                    </span>
                    <span className='font-sans text-sm font-semibold text-white'>
                      {t(`cards.${card.key}.type`)}
                    </span>
                  </div>

                  {/* Giá */}
                  <div className='flex items-center justify-between border-t border-[#333] pt-2.5'>
                    <span className='font-sans text-sm text-[#d1d1d1]'>
                      {t('label_price')}
                    </span>
                    <span className='font-sans text-sm font-semibold text-white'>
                      {t(`cards.${card.key}.price`)}
                    </span>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className='pt-2'>
                <Button
                  variant='white'
                  className='h-auto w-full rounded-full bg-white px-10 py-3.5 font-criteria text-base uppercase text-black hover:bg-neutral-200'
                  asChild
                >
                  <Link href={card.href}>
                    <span>{t('cta')}</span>
                    <ArrowUpRight className='size-5 text-black' />
                  </Link>
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
